import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IReadReceiptListItem, ReadReceiptListItem } from "./readReceiptListItem";

export interface IReadReceiptListItems extends ListItems<IReadReceiptListItem> {
}

export class ReadReceiptListItems extends ListItems<ReadReceiptListItem> implements IReadReceiptListItems {
    constructor();
    constructor(obj: IReadReceiptListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, ReadReceiptListItem);
    }
}